const theme = {
  colors: {
    primary: `#F15D2E`,
    primaryHover: `#D54927`,
    secondary: `#5D412D`,
    secondaryHover: `#3C2413`,
    tertiary: `#EFEFEC`,
    tertiaryHover: `#DEDCD8`,
    bodyFont: `#3c2413`,
    gray: `#efefef`,
    lightGray: `#f9f7f5`,
  },
  breakpoints: ["700px", "1050px", "1350"],
  spacing: {
    paddingDefault: `2rem`,
    marginDefault: `5rem`,
  },
}

export default theme
